export const isDefined = (value) => value !== undefined && value !== null;
//# sourceMappingURL=isDefined.js.map